import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
 #STATUS-INDICATOR
\*------------------------------------ */
/**
 * 1) Status indicators with the type contained is text with a color background
 */
.cat-c-status-indicator {
  font-family: var(--cat-theme-typography-label-sm-font-family);
  font-weight: var(--cat-theme-typography-label-sm-font-weight);
  font-size: var(--cat-theme-typography-label-sm-font-size);
  line-height: var(--cat-theme-typography-label-sm-line-height);
  display: inline-block;
  align-items: center;
  justify-content: center;
  text-align: center;
  word-break: break-word;
  hyphens: auto;
  width: var(--cat-status-indicator-width, auto);
  padding: var(--cat-space-3x-small) calc(var(--size-base-unit) * 1.0625);
  border-radius: 200px;
  color: var(--cat-theme-color-content-knockout);
  background-color: var(--cat-theme-color-status-neutral);
}

/**
 * Small status indicator
 */
.cat-c-status-indicator--sm {
  padding: 0px calc(var(--size-base-unit) * 0.5625);
}

/**
 * Active status indicator
 */
.cat-c-status-indicator--active {
  background-color: var(--cat-theme-color-status-active);
}

/**
 * Warning status indicator
 */
.cat-c-status-indicator--warning {
  background-color: var(--cat-theme-color-border-utility-warning);
}

/**
 * Error status indicator
 */
.cat-c-status-indicator--error {
  background-color: var(--cat-theme-color-status-danger);
}

/**
 * Canceled status indicator
 */
.cat-c-status-indicator--indetermined {
  background-color: var(--cat-theme-color-status-intermediate);
}

/*
  * Disabled status indicator
*/
.cat-c-status-indicator--disabled {
  background-color: var(--cat-theme-color-status-disabled);
  color: var(--cat-theme-color-status-intermediate);
  pointer-events: none;
}

/**
 * 2) Status indicators are text with a color indicator
 */
.cat-c-status-indicator--bare {
  padding: 0;
  border-radius: 0;
  color: var(--cat-theme-color-content-default);
  background-color: transparent;
  display: inline-flex;
  align-items: baseline;
  gap: var(--cat-space-3x-small);
  /**
   * Text within the status indicator
   */
}
.cat-c-status-indicator--bare .cat-c-status-indicator__icon {
  --cat-icon-fill: var(--cat-theme-color-content-utility-information);
  --cat-icon-height: var(--cat-space-small);
  --cat-icon-width: var(--cat-space-small);
  position: relative;
  top: 1px;
}
.cat-c-status-indicator--bare span {
  text-align: start;
}

/**
 * Bare active status indicator
 */
.cat-c-status-indicator--bare.cat-c-status-indicator--active .cat-c-status-indicator__icon {
  /**
   * Icon before the text
   */
  --cat-icon-fill: var(--cat-theme-color-content-utility-success);
}

/**
 * Bare warning status indicator
 */
.cat-c-status-indicator--bare.cat-c-status-indicator--warning .cat-c-status-indicator__icon {
  /**
   * Icon before the text
   */
  --cat-icon-fill: var(--cat-theme-color-border-utility-warning);
}

/**
 * Bare error status indicator
 */
.cat-c-status-indicator--bare.cat-c-status-indicator--error .cat-c-status-indicator__icon {
  /**
   * Icon before the text
   */
  --cat-icon-fill: var(--cat-theme-color-content-utility-error);
}

/**
 * Bare canceled status indicator
 */
.cat-c-status-indicator--bare.cat-c-status-indicator--indetermined .cat-c-status-indicator__icon {
  /**
   * Icon before the text
   */
  --cat-icon-fill: var(--cat-theme-color-background-strong);
}

/**
 * Bare disabled status indicator
 */
.cat-c-status-indicator--bare.cat-c-status-indicator--disabled {
  color: var(--cat-theme-color-status-intermediate);
}
.cat-c-status-indicator--bare.cat-c-status-indicator--disabled .cat-c-status-indicator__icon {
  --cat-icon-fill: var(--cat-theme-color-background-disabled);
}

.cat-c-status-indicator:not(.cat-c-status-indicator--has-before-slot) .cat-c-status-indicator__icon {
  display: none;
}
`;
       